export default __webpack_public_path__ + "static/media/0.53.d13d7b22.jpg";